<cll-dialog-layout>
    <cll-dialog-header>
        <cll-dialog-title>
            Mark Zone as
            @if (zone.status) {
                active
            } @else {
                inactive
            }
        </cll-dialog-title>
        <cll-dialog-subtitle>{{ zone.name }}</cll-dialog-subtitle>

    </cll-dialog-header>
    <div class="dialog-container">
        <div class="dialog-detail">
            <cll-panel-tonal colour="info">
                <cll-icon cllPanelIcon>info</cll-icon>
                <div class="panel-text-group">
                    @if (!zone.status) {
                        <span class="panel-text-header">Mark as inactive</span>
                        <span
                            class="panel-text-sub-header">This zone will no longer be available for selection.</span>
                    } @else {
                        <span class="panel-text-header">Mark as active</span>
                        <span class="panel-text-sub-header">This zone will become available for selection.</span>
                    }
                </div>
            </cll-panel-tonal>
            <span>Are you sure you want to proceed?</span>
        </div>
    </div>
    <span class="dialog-divider"></span>
    <cll-dialog-footer>

        @if (updateZoneRequest.error(); as error) {
            <app-error-panel [error]="error" />
        }

        <button cll-button
                colour="variant"
                cllDialogClose>
            Cancel
        </button>
        <button cll-filled-button
                colour="secondary"
                [disabled]="this.updateZoneRequest.loading()"
                (click)="update()">
            Confirm
        </button>
    </cll-dialog-footer>
</cll-dialog-layout>
